import { cordinatesInventory } from '../../../pages/Inventary/components/table/BodyTemplatesTable';

export function formatDateTime(date: string) {
  const d = new Date(date);
  return d.toLocaleString('es-MX', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });
}

export const defaultColumnsSandboxTable = [
  {
    field: 'SamId',
    header: 'SAM ID',
    sortable: true,
    width: '100px',
    isFilter: true,
    dataType: undefined,
    //body: (rowData: any) => formatDateTime(rowData.date),
  },
  {
    field: 'SamStatus',
    header: 'Estatus',
    sortable: true,
    width: '100px',
    isFilter: true,
    dataType: undefined,
  },
  {
    //falta esta
    field: 'LocationGpsObject',
    header: 'Coordenadas de registro',
    sortable: true,
    width: '100px',
    isFilter: true,
    dataType: undefined,
    body: cordinatesInventory,
  },
  {
    field: 'TechnologicalOperator',
    header: 'Operador tecnológico',
    sortable: true,
    width: '100px',
    isFilter: true,
    dataType: undefined,
  },
  {
    field: 'Project',
    header: 'Proyecto',
    sortable: true,
    width: '100px',
    isFilter: true,
    dataType: undefined,
  },
  {
    field: 'SamType',
    header: 'Tipo de SAM',
    sortable: true,
    width: '100px',
    isFilter: true,
    dataType: undefined,
  },
  {
    field: 'TransportCompanyName',
    header: 'Compañía',
    sortable: true,
    width: '100px',
    isFilter: true,
    dataType: undefined,
  },
  {
    field: 'RouteName',
    header: 'Nombre ruta',
    sortable: true,
    width: '100px',
    isFilter: true,
    dataType: undefined,
  },
  {
    field: 'RouteNumber',
    header: 'Número de ruta',
    sortable: true,
    width: '100px',
    isFilter: true,
    dataType: undefined,
  },
  {
    //falta este
    field: 'Name',
    header: 'Usuario que registró',
    sortable: true,
    width: '100px',
    isFilter: true,
    dataType: undefined,
  },
  {
    field: 'CreatedOn',
    header: 'Fecha creación',
    sortable: true,
    width: '100px',
    isFilter: true,
    dataType: undefined,
  },
];
